var path = 'C:/Projects/repos/NAERS-Web/src/components/app/account/account.html';
var html = "<div layout=column layout-padding flex> <div layout=row layout-wrap> <md-button class=\"md-raised md-accent md-button-lg\" aria-label=\"Change Password\" ng-click=$ctrl.showChangePassword() flex-xs=100> <md-icon md-font-set=material-icons>vpn_key</md-icon> Change Password </md-button> </div> <div layout=column flex> <user-edit-form access-levels=$ctrl.accessLevels show-access-level=false user=::$ctrl.user on-user-changed=$ctrl.updateAccount($event) layout=column flex> </user-edit-form> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/account/account.html
// module id = 520
// module chunks = 0